
import CustomModal from "../CustomModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from "react";
import { useLocations } from "../../../hooks/useLocations";

function EditMemberModal({
  isOpen,
  handleCloseModals,
  profileImage,
  handleFileChange,
  memberData,
  handleInputChange,
  handleDateChange,
  handleSave,
}) {
  const { locations, loading: loadingLocations } = useLocations(isOpen);

  const handleLocationChange = (e) => {
    handleInputChange({ target: { name: "location_id", value: e.target.value } });
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={handleCloseModals}
      className="add-admin-modal"
      hideFooter={true}
    >
      <div className="form-container">
        <div className="inner-form">
          <div className="add-staff-head">
            <h2>Member Details</h2>
          </div>

          <div className="add-staff-image">
            <div className="add-staff-image-pic">
              <img
                src={profileImage}
                alt="Profile Preview"
                width="36px"
                height="36px"
              />
              <div className="add-staff-image-text">
                <p>Upload member's picture</p>
                <p>PNG OR JPG</p>
              </div>
            </div>
            <input
              type="file"
              accept="image/png, image/jpeg, image/jpg"
              onChange={handleFileChange}
              style={{ display: "none" }}
              id="upload-picture"
            />
            <label htmlFor="upload-picture" style={{ cursor: "pointer" }}>
              Upload picture
            </label>
          </div>

          <div className="form-input">
            <div className="member-name">
              <div id="member-fname">
                <label htmlFor="firstName">First Name</label>
                <input
                  id="firstName"
                  name="firstName"
                  value={memberData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div id="member-lname">
                <label htmlFor="lastName">Last Name</label>
                <input
                  id="lastName"
                  name="lastName"
                  value={memberData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <label htmlFor="phoneNumber">Phone Number</label>
            <input
              id="phoneNumber"
              name="phoneNumber"
              type="number"
              value={memberData.phoneNumber}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              value={memberData.email}
              type="email"
              onChange={handleInputChange}
              required
            />


            <label htmlFor="address">Address</label>
            <input
              id="address"
              name="address"
              value={memberData.address}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="location_id">Location</label>
            <select
              id="location_id"
              name="location_id"
              value={memberData.location_id || ''}
              onChange={handleLocationChange}
              required
              disabled={loadingLocations}
              style={{ marginBottom: 12 }}
            >
              <option value="" disabled>
                {loadingLocations ? 'Loading locations...' : 'Select a location'}
              </option>
              {locations.map(loc => (
                <option key={loc.id} value={loc.id}>{loc.name}</option>
              ))}
            </select>

            <label htmlFor="dateOfBirth">Date of Birth</label>
            <div className="date-picker">
              <DatePicker
                selected={memberData.dateOfBirth}
                onChange={(date) => handleDateChange(date, "dateOfBirth")}
                showPopperArrow={false}
                dateFormat="dd-MM-yyyy"
                placeholderText="Select a date"
              />
            </div>

            <label htmlFor="profession">Profession</label>
            <input
              id="profession"
              name="profession"
              value={memberData.profession}
              onChange={handleInputChange}
              required
            />

            <label htmlFor="NIN">National Identification Number (NIN)</label>
            <input
              id="NIN"
              name="NIN"
              value={memberData.NIN}
              type="number"
              onChange={handleInputChange}
              required
              pattern="\d{11}"
              onInvalid={(e) =>
                e.target.setCustomValidity("NIN must be exactly 11 digits")
              }
              onInput={(e) => e.target.setCustomValidity("")}
            />
          </div>
        </div>
      </div>

      <div className="modal-button">
        <button onClick={handleCloseModals}>Cancel</button>
        <button
          style={{ backgroundColor: "#0473BD", color: "white" }}
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </CustomModal>
  );
}

export default EditMemberModal;
